import React from 'react'
import {useForm} from 'react-hook-form'
import {useWarrantyContext} from '../util/warranty-context'
import Field from '../../../components/field'
import WarrantyFooter from './warranty-footer'
import WarrantyHeader from './warranty-header'
import WarrantyFormContainer from './warranty-form-container'
import WarrantyStepContainer from './warranty-step-container'
import {useCurrentCustomer} from '../../../hooks/use-current-customer'
import useAddressFields from '../../../components/forms/useAddressFields'
import useGlobalFields from '../../../components/forms/useGlobalFields'
import {Text} from '@chakra-ui/react'
import useAutocompleteAddress from '../../../components/forms/useAutocompleteAddress'
import {FormattedMessage} from 'react-intl'

const CustomerDetails = () => {
    const {data, onSubmit: _onSubmit} = useWarrantyContext()

    const onSubmit = ({
        firstName,
        lastName,
        email: personEmail,
        phone,
        address1: billingStreet,
        city: billingCity,
        stateCode: billingState,
        postalCode: billingPostalCode
    }) =>
        _onSubmit({
            firstName,
            lastName,
            personEmail,
            phone,
            billingStreet,
            billingCity,
            billingState,
            billingPostalCode
        })

    const form = useForm({
        defaultValues: {
            firstName: data?.firstName,
            lastName: data?.lastName,
            email: data?.personEmail,
            phone: data?.phone,
            address1: data?.billingStreet,
            city: data?.billingCity,
            stateCode: data?.billingState,
            postalCode: data?.billingPostalCode
        }
    })

    const globalFields = useGlobalFields({form})
    const addressFields = useAddressFields({form})
    const {ref: autocompleteRef} = useAutocompleteAddress(form)

    const fields = {
        firstName: globalFields.firstName,
        lastName: globalFields.lastName,
        email: {
            ...globalFields.email,
            rules: {
                ...globalFields.email.rules,
                required: false
            }
        },
        phone: {
            ...globalFields.phone,
            rules: {
                ...globalFields.phone.rules,
                required: false
            }
        },
        address1: addressFields.address1,
        city: addressFields.city,
        stateCode: addressFields.stateCode,
        postalCode: addressFields.postalCode
    }

    return (
        <form noValidate onSubmit={form.handleSubmit(onSubmit)}>
            <WarrantyStepContainer>
                <WarrantyHeader>
                    <FormattedMessage
                        defaultMessage="Enter your customer details"
                        id="warranty_portal.customer_details.header"
                    />
                </WarrantyHeader>

                <Text>{data.userInputSelectedProductName}</Text>

                <WarrantyFormContainer>
                    <Field {...fields.firstName} />
                    <Field {...fields.lastName} />
                    <Field {...fields.email} />
                    <Field {...fields.phone} />
                    <Field {...fields.address1} ref={autocompleteRef} />
                    <Field {...fields.city} />
                    <Field {...fields.stateCode} />
                    <Field {...fields.postalCode} />
                </WarrantyFormContainer>

                <WarrantyFooter />
            </WarrantyStepContainer>
        </form>
    )
}

const CustomerDetailsContainer = () => {
    const {
        isInitialLoading,
        data: {customerType}
    } = useCurrentCustomer()

    // wait for the customer to load before rendering the component or the defaults will not be set correctly
    if (isInitialLoading || customerType == null) {
        return null // or a loading spinner
    }

    return <CustomerDetails />
}

export default CustomerDetailsContainer
